export const UpdateTidbitActionTypes = {
  UPDATE_TIDBIT_LOADING: "UPDATE_TIDBIT_LOADING",
  UPDATE_TIDBIT_ERROR: "UPDATE_TIDBIT_ERROR",
  UPDATE_TIDBIT_SUCCESS: "UPDATE_TIDBIT_SUCCESS",
};
